import $ from 'jquery'

function initDownloadsBlock () {
   
}

export { initDownloadsBlock }
